

export const isPrintUserWht = {isPrintUser: false, isPrintDate: false}